/**
 * Ce qu'Affinicar facture au vendeur pour un contrat.
 *
 * `servicePrice` et `assistancePrice` sont DEUX colonnes distinctes qui
 * s'additionnent : le supplément d'assistance ne remplace pas la prestation. Toute
 * somme facturée — et donc tout avoir qui la rend — porte sur leur total. Miroir de
 * `billedServiceHt` côté API, dont les avoirs reprennent le calcul.
 *
 * Centralisé ici parce que deux modales l'annoncent à l'utilisateur avant un geste
 * irréversible : l'offre d'un contrat et son annulation avec avoir. Un écart entre
 * les deux, ou avec l'API, se paierait en euros.
 */

/** Total hors taxe facturé au vendeur. */
export function billedServiceHt(
  servicePrice: number | null | undefined,
  assistancePrice: number | null | undefined,
): number {
  return (servicePrice || 0) + (assistancePrice || 0);
}

/** Le même total toutes taxes comprises, au centime, comme l'avoir l'enregistre. */
export function billedServiceTtc(
  servicePrice: number | null | undefined,
  assistancePrice: number | null | undefined,
): number {
  return (
    Math.round(billedServiceHt(servicePrice, assistancePrice) * 1.2 * 100) / 100
  );
}
